import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { Config } from './config.service';

export * from './config.service';

export function provideConfig(): EnvironmentProviders {
  return makeEnvironmentProviders([Config]);
}
